import { StoreDashboardState } from '@dashboard/dashboard-store/dashboard.state';
import { createAction, props } from '@ngrx/store';

type State = StoreDashboardState;

enum TEST_ACTIONS {
  SET_REDUX_STATE = '[TEST] SET_REDUX_STATE',
}

const SetReduxStateAction = createAction(
  TEST_ACTIONS.SET_REDUX_STATE,
  props<{
    state: StoreDashboardState;
  }>()
);

export { SetReduxStateAction };
